module.exports = "/assets/data/f102d43b9bf1947a88412098805946d8-EN3.data.json";